import { type Product } from '../@types/Product.js';

export type ProductConfig = {
  groups: 1 | 2;
  outcomeBounds: [number, number];
  eventBounds: [number, number];
  rowPrice: [number, number];
  numberOfDraws: number[];
};

/**
 * groups: number of outcome groups, usually 1 for 1X2 products and 2 for Score products
 * outcomeBounds: [min, max] minimum and maximum number of outcomes within an event
 * eventBounds: [min, max] minimum and maximum number of events within a draw
 * rowPrice: [min, max] minimum and maximum row price
 */
const PRODUCT_CONFIG: Record<Product, ProductConfig> = {
  Bomben: {
    groups: 2,
    outcomeBounds: [10, 10],
    eventBounds: [2, 4],
    rowPrice: [1, 500],
    numberOfDraws: [1],
  },
  Matchen: {
    groups: 2,
    outcomeBounds: [255, 255],
    eventBounds: [1, 1],
    rowPrice: [1, 500],
    numberOfDraws: [1],
  },
  Fulltraff: {
    groups: 1,
    outcomeBounds: [7, 7],
    eventBounds: [13, 13],
    rowPrice: [1, 1],
    numberOfDraws: [1, 5, 10],
  },
  Challenge: {
    groups: 1,
    outcomeBounds: [2, 3],
    eventBounds: [6, 8],
    rowPrice: [5, 50], // This is not used for Challenge because minPrice is set by draw, not product
    numberOfDraws: [1],
  },
  Stryktipset: {
    groups: 1,
    outcomeBounds: [3, 3],
    eventBounds: [13, 13],
    rowPrice: [1, 1],
    numberOfDraws: [1, 5, 10],
  },
  Europatipset: {
    groups: 1,
    outcomeBounds: [3, 3],
    eventBounds: [13, 13],
    rowPrice: [1, 1],
    numberOfDraws: [1],
  },
  Topptipset: {
    groups: 1,
    outcomeBounds: [3, 3],
    eventBounds: [8, 8],
    rowPrice: [1, 10],
    numberOfDraws: [1],
  },
  Powerplay: {
    groups: 1,
    outcomeBounds: [3, 3],
    eventBounds: [8, 8],
    rowPrice: [1, 10],
    numberOfDraws: [1],
  },
  TopptipsetExtra: {
    groups: 1,
    outcomeBounds: [3, 3],
    eventBounds: [8, 8],
    rowPrice: [1, 10],
    numberOfDraws: [1],
  },
  TopptipsetStryk: {
    groups: 1,
    outcomeBounds: [3, 3],
    eventBounds: [8, 8],
    rowPrice: [1, 10],
    numberOfDraws: [1],
  },
  Maltipset: {
    groups: 1,
    outcomeBounds: [1, 30],
    eventBounds: [8, 14],
    rowPrice: [2.5, 2.5],
    numberOfDraws: [1, 5, 10],
  },
  Sportkrysset: {
    groups: 1,
    outcomeBounds: [9, 9],
    eventBounds: [7, 7],
    rowPrice: [1, 3],
    numberOfDraws: [1, 5, 10],
  },
};

/**
 * Returns product specific configuration.
 *
 * @param product - Product to get config for
 * @returns - Product specific config
 */
export function getProductConfig(product: Product): ProductConfig {
  const productConfig = PRODUCT_CONFIG[product];

  return productConfig;
}
